import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EventService } from '../services/event.service';
import { checkoutAddress } from '../models/user-data.models';
import { UserData } from '../models/user-data.models';

@Injectable({
  providedIn: 'root'
})
export class CheckoutGuard implements CanActivate, OnDestroy {
  checkoutAddress!: checkoutAddress;
  editorAccess:boolean;
  ngUnsubscribe = new Subject<void>();
  constructor(
    private eventService: EventService,
    private router : Router
    ) {
      this.eventService.checkoutAddress.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: checkoutAddress)=>{
        this.checkoutAddress = res;
       })
       this.eventService.userData.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: UserData)=>{
        this.editorAccess = res.editorAccess
       })
     }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // this.router.navigate(['/'])
      // return false;
      if(this.checkoutAddress && this.checkoutAddress.leadId && this.editorAccess){
        return true;
      } else {
        this.router.navigate(['/'])
        return false;
      }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
}
